import type { OrganizationDolly, OrganizationDollyFields, OrganizationDollyResponse } from './types';

export function mapOrganizationDolly(data: OrganizationDollyResponse): OrganizationDolly {
  return {
    topicId: data.topic_id,
    cutoff: data.cutoff,
    frequency: data.frequency,
    customSchedule: data.custom_schedule,
    feeds: data.feeds,
    schedule: data.schedule,
    triggerSms: data.trigger_sms,
    smsRateLimit: data.sms_rate_limit,
    createdAt: data.created_at,
    updatedAt: data.updated_at,
  };
}

/** camelCase fields to the snake_case body; undefined fields stay out of the request. */
export function mapOrganizationDollyFieldsToBody(fields: OrganizationDollyFields): Record<string, unknown> {
  /* eslint-disable camelcase */
  const body: Record<string, unknown> = {
    cutoff: fields.cutoff,
    frequency: fields.frequency,
    custom_schedule: fields.customSchedule,
    feeds: fields.feeds,
    schedule: fields.schedule,
    trigger_sms: fields.triggerSms,
    sms_rate_limit: fields.smsRateLimit,
  };
  /* eslint-enable camelcase */

  return Object.fromEntries(Object.entries(body).filter(([, value]) => value !== undefined));
}
